class EntryFilters {
    constructor() {
        this.filterInputs = document.querySelectorAll('.js-filter-input');
    }

    bindInputs() {
        const { filterInputs } = this;
        filterInputs.forEach((input) => {
            input.addEventListener('change', (e) => {
                e.preventDefault();
                if (e.target.value === 'showAll') {
                    this.clearFilters();
                } else {
                    this.clearShowAll();
                }
            });
        });
    }

    clearFilters() {
        const { filterInputs } = this;
        filterInputs.forEach((input) => {
            if (input.value !== 'showAll') {
                input.checked = false;
            }
        });
    }

    clearShowAll() {
        const { filterInputs } = this;
        filterInputs.forEach((input) => {
            if (input.value === 'showAll') {
                input.checked = false;
            }
        });
    }

    init() {
        if (this.filterInputs.length > 0) {
            this.bindInputs();
        }
    }
}

export default EntryFilters;



// WEBPACK FOOTER //
// ../project/craft/src/components/filters/filters.js